import React, {useEffect, useState} from 'react';
import {Portlet, PortletHeader} from "../../../components/Portlet";
import BlockUi from "@availity/block-ui";
import axios from "../../../helpers/axios";
import {Link} from "react-router-dom";
import {CheckRoute, TouristServicesListRoute} from "../../routesConstants";
import moment from "moment";
import AllInfoItem from "./AllInfoItem";




const CheckAllInfo = () => {
  const [data, setData] = useState()
  const [loading, setLoading] = useState(true)
  const [message, setMessage] = useState()



  useEffect(() => {
    axios.post("/api/dashboard/checkAllInfo")
      .then(({data})=>{
        console.log('checkAllInfo',data)
        if(!data.data){
          setMessage(data.message)
        }
        setData(data.data)
      }).finally(()=>setLoading(false))

  }, []);

  return (
    <Portlet>
      <PortletHeader title={'Есть ли проблемы за 2 мес.?'}/>
      <BlockUi blocking={loading}>
        {data && Object.keys(data).map((key,i)=>{
          return <React.Fragment key={i}>
            <AllInfoItem data={data} item={key}/>
          </React.Fragment>
        })}
        {message && <div className={'text-center'}>{message}</div>}
      </BlockUi>
    </Portlet>
  );
};

export default CheckAllInfo;
